
import { mapActions, mapGetters } from 'vuex'
import store from '../../config/store'

export default {
  components: {
    'component-alert': () => import(/* webpackChunkName: "components" */ '@/common/components/Alert.vue'),
    'component-button': () => import(/* webpackChunkName: "components" */ '@/common/components/Button.vue'),
    PhoneInput: () => import(/* webpackChunkName: "components" */ '@/common/components/PhoneInput.vue'),
    'toggle-switch': () => import(/* webpackChunkName: "components" */ '@/common/components/ToggleSwitch.vue'),
  },

  props: {
    existingBeneficiary: {
      type: Object,
      default: null
    },

    existingAddress: {
      type: Object,
      default: null
    },

    enableNoSepa: {
      type: Boolean,
      default: true
    }
  },

  data: () => ({
    store,
    formSubmited: false,
    beneficiary: {
      label: '',
      short_tag: '',
      iban: '',
      phone_number: '',
      email: '',
      comment: '',
      list_id: 0,
      bic: '',
      bank_details: {
        name: '',
        country: '',
      },
      international: false,
    },
    address: {
      street: '',
      zip: '',
      city: '',
      country: ''
    },
    isIbanIncorrect: false,
    importedBeneficiaryLabel: false,
    createBeneficiaryAction: 'create-beneficiary'
  }),

  computed: {
    
    ...mapGetters([
      'beneficiaryLists',
      'beneficiariesList',
      'beneficiaryCountries'
    ]),
    
    isListEmployee () {
      return false
    },

    isExistingBeneficiary () {
      return this.$parent.isExistingBeneficiary
    },

    isInSidepanel () {
      return this.$parent.sidePanelVue
    },

    beneficiaryData () {
      const beneficiary = { ...this.beneficiary }
      beneficiary.rib = this.$parent.beneficiary.rib || null
      beneficiary.address = { ...this.address }
      if (!this.beneficiary.international) {
        delete beneficiary.bic
        delete beneficiary.bank_details
      }
      return beneficiary
    }
  },

  watch: {
    'store.error.code': function () {
      if (store.error.code === 422) {
        store.error.fields.forEach(item => {
          this.errors.add({ field: item.field, msg: item.message })
        })
        this.$bus.$emit('scrollToTop')
      }
    }
  },
  
  mounted () {
    if (this.$route.params.listId) {
      this.beneficiary.list_id = parseInt(this.$route.params.listId)
    }
    
    if (this.isExistingBeneficiary) {
      const beneficiary = this.beneficiariesList.beneficiaries.find(beneficiary => beneficiary.id === parseInt(this.$route.params.beneficiaryId))
      if (beneficiary) {
        Object.assign(this.beneficiary, beneficiary)
        Object.assign(this.address, beneficiary.address)
      }
    }

    if (!this.beneficiaryCountries.length) {
      this.getBeneficiaryCountries()
    }

    if (this.existingBeneficiary) {
      Object.assign(this.beneficiary, this.existingBeneficiary)
    }

    if (store.sidepanel.hasOwnProperty('dataModel') && store.sidepanel.dataModel.hasOwnProperty('beneficiary')) {
      this.importedBeneficiaryLabel = true
    }

    this.$bus.$on('password-checked', this.onPasswordChecked)
  },

  destroyed () {
    this.$bus.$off('password-checked', this.onPasswordChecked)
  },

  methods: {
    
    ...mapActions([
      'createBeneficiary',
      'editBeneficiary',
      'getBeneficiaryCountries',
      'validateIban'
    ]),
    
    onSubmit () {
      this.formSubmited = true
      this.$validator.validateAll().then((result) => {
        if (result && !this.isIbanIncorrect) {
          this.checkPassword()
        } else {
          store.error.fields = []
          this.$bus.$emit('scrollToTop')
        }
      })
    },

    checkPassword () {
      this.showModal({
        childVue: 'check-password',
        wrapperClass: 'modal modal--xs',
        dataModel: {
          action: this.createBeneficiaryAction
        },
        blockLeaveBackground: true
      })
    },

    onPasswordChecked (action) {
      if (action === this.createBeneficiaryAction) {
        if (this.isExistingBeneficiary) {
          this.editBeneficiary(this.beneficiaryData).then(() => {
            this.showBanner('success', this.$i18n.t('banner.success.beneficiary.edit'))
            this.$router.push(`/transfers/beneficiaries-list/${this.beneficiaryData.list_id}`)
          })
        } else {
          this.createBeneficiary(this.beneficiaryData).then(response => {
            if (this.isInSidepanel) {
              this.$bus.$emit('beneficiary-save-success', response.data)
            } else {
              this.showBanner('success', this.$i18n.t('banner.success.beneficiary.create'))
              this.$router.push(`/transfers/beneficiaries-list/${this.beneficiaryData.list_id}`)
            }
          })
        }
      }
    },
    
    onCancel () {
      if (this.isInSidepanel) {
        this.hideSidePanel()
      } else if (this.isExistingBeneficiaryList) {
        this.$router.push('/transfers/beneficiaries-list/' + this.$route.params.listId)
      } else {
        this.$router.push('/transfers/beneficiary-lists')
      }
    },

    onIbanChange () {
      if (this.beneficiary.iban.length && !this.errors.items.find(o => o.field === 'iban')) {
        this.validateIban(this.beneficiary.iban).then(response => {
          this.isIbanIncorrect = false
          this.beneficiary.international = response.data.international
          this.beneficiary.bank_details.country = response.data.country_iso
        }, () => {
          this.isIbanIncorrect = true
        })
      }
    }
  }
}
